import styled from 'styled-components'
import { Accordion } from '@sainsburys-tech/bolt'

const AccordionItem = styled(Accordion.Item)`
  width: 100%;
`

const Container = styled.div`
  display: flex;
  margin-bottom: 15px;
`

const QuestionHeading = styled.h4`
  &&& {
    font-size: ${props => props.theme.font.size['display-3']};
    margin-bottom: 15px;
  }
`

const QuestionBody = styled.p`
  font-size: ${props => props.theme.font.size.base};
  &&& {
    margin-bottom: 15px;
  }
`

const Oval = styled.div`
  color: ${props => (props.type === 'Q' ? '#d42114' : props.theme.color.palette['brand-1'])};
  background-color: ${props => (props.type === 'Q' ? '#ffeeed' : props.theme.color.palette['brand-1-light'])};
  border-radius: 15px;
  font-size: ${props => props.theme.font.size.base};
  font-weight: ${props => props.theme.font.weight.bold};
  line-height: ${props => props.theme.font.stack['body-1']['line-height']};
  height: 30px;
  width: 30px;
  margin-right: 15px;
  padding-top: 2px;
  text-align: center;
  flex-shrink: 0;
`

const PersonInformation = styled.div`
  margin-top: ${props => (props.question ? '-15px' : '0px')};
  margin-left: ${props => (props.question ? '45px' : '0px')};
  margin-bottom: 15px;
  color: ${props => props.theme.color.monochrome.dark};
`

const AnswerLink = styled.div`
  margin-bottom: 15px;
  margin-left: 45px;
  a {
    display: block;
  }
`

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const AccordionTitle = styled.div`
  display: flex;
`

const AnswerContents = styled.div`
  margin-left: 45px;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
    margin-left: 0px;
  }
`

const Answer = styled.div`
  display: flex;
  margin-bottom: 15px;
  margin-top: 30px;
`

const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
    > button {
      width: 100%;
    }
  }
`

export {
  AccordionItem,
  Container,
  QuestionHeading,
  QuestionBody,
  Oval,
  PersonInformation,
  AnswerLink,
  FlexColumn,
  AccordionTitle,
  AnswerContents,
  Answer,
  ButtonContainer
}
